// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2601":"8c5a47ce","5197":"2d7912ed","6394":"9da68769"}[chunkId] + ".chunk.css";
};